<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="contentBox w">
      <div class="contentStitle">news information</div>
      <div class="contentTitle">新闻资讯</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="information">
        <div class="information_title">
          <div class="title_left">云久鸿简介</div>
          <div class="title_right">></div>
        </div>
        <div class="information_introduce">
          <div class="introduce_left">
            <p>
              深圳市云久鸿劳务派遣有限公司于2010年5月在深圳市龙华区成立，总部位于深圳市龙华区福城街道新和社区观澜大道111号101富嘉商务中心，是一家专业的人力资源平台。
            </p>
            <p>
              云久鸿始终秉持着诚信、责任、共赢、感恩的企业价值观，以用心服务，筑就行业新高度为使命，为打造值得全球信赖的就业服务平台而不懈努力。
            </p>
            <p>
              经过10余年的发展，云久鸿已成为人力资源行业的领先企业，被深圳龙华区人民政府评定为服务业百强企业。
            </p>
            <p>
              现设云久鸿劳务派遣有限公司、云久鸿人力资源有限公司、景上鸿劳务派遣有限公司、云富鸿人力资源有限公司、蓝聘人力资源有限公司等多家子公司，并在深圳各个区设立了多家线下门店。
            </p>
            <p>
              迄今为止，公司已服务企业客户达500多家，为富士康、比亚迪、伯恩光学、天马微等多家500强名企输送数以万计的人力资源。
            </p>
          </div>
          <div class="introduce_right">
            <img :src="src.qyfw" alt="" />
          </div>
        </div>
        <!-- tab栏 -->
        <!-- <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="0">全部</el-menu-item>
          <el-menu-item index="3">消息中心</el-menu-item>
        </el-menu> -->
        <!-- 新闻列表 -->
        <div class="itemList" v-if="newsList.length > 0">
          <div
            class="item"
            v-for="(item, index) in newsList"
            :key="index"
            @click="toDetail(item.id)"
          >
            <div class="itemLeft">
              <div class="index">{{ index + 1 }}</div>
              <div class="time">{{ item.created_at }}</div>
            </div>
            <div class="itemRight">
              <div class="itemTitle">{{ item.title }}</div>
              <div class="itemContent">
                {{ item.sub_title }}
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
      </div>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import axios from "axios";
import $ from "jquery";
import src from "../../utils/assets";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
  },
  data() {
    return {
      src: src,
      form: {
        type: 0,
        category_id: 0,
        page: 1,
        limit: 15,
      },
      idnex: "3-1",
      activeIndex: "0",
      newsList: [],
    };
  },
  created() {
    this.getNewsList();
    // this.getNewsType();
  },
  mounted() {},
  methods: {
    toDetail(id) {
      // this.$router.push({
      //   name: "newsDetails",
      //   params: {
      //     id: id,
      //   },
      // });
      // this.$router.push({
      //   path: `/particulars/${id}`,
      // });
      this.$router.push({
        path: "/newsDetails",
        query: {
          id: id,
        },
      });
    },
    getNewsList() {
      const _this = this;
      axios
        .get(process.env.VUE_APP_URL + "/api/news/index", { params: _this.form })
        .then(function (res) {
          console.log(res);
          if (res.data.code == 0) {
            _this.newsList = res.data.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // getNewsType() {
    //   const _this = this;
    //   axios
    //     .get(process.env.VUE_APP_URL + "/api/news/category?limit=" + _this.limit)
    //     .then(function (res) {
    //       console.log(res);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },
  },
};
</script>

<style lang="less" scoped>
.information {
  width: 1000px;
  margin: 0 auto;
  .information_title {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #da261d;
    font-size: 40px;
    line-height: 80px;
    .title_right {
      color: #da261d;
      font-weight: 700;
    }
  }
  .information_introduce {
    display: flex;
    justify-content: space-between;
    .introduce_left {
      padding: 20px;
      p {
        font-size: 14px;
        text-align: left;
        line-height: 30px;
      }
    }
    img {
      width: 415px;
      height: 270px;
      margin: 20px;
    }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #da261d;
    color: #303133;
  }
  .itemList {
    .item {
      padding: 35px 0;
      display: flex;
      border: 1px solid #cccccc;
      .itemLeft {
        width: 133px;
        height: 150px;
        border: 1px solid #cccccc;
        border-left: none;
        .index {
          height: 80%;
          background-color: #cccccc;
          font-size: 40px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 120px;
          text-align: center;
        }

        .time {
          height: 20%;
          line-height: 30px;
          text-align: center;
          color: #cccccc;
        }
      }

      .itemRight {
        width: 750px;
        margin: 0 50px;
        text-align: left;
        .itemTitle {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #cccccc;
          margin-bottom: 40px;
        }

        .itemContent {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #cccccc;
          line-height: 24px;
        }
      }
    }
    .item:hover {
      border: 1px solid #da261d;
      .itemLeft {
        border: 1px solid #da261d;
        .index {
          background-color: #da261d;
        }
        .time {
          color: #da261d;
        }
      }
      .itemRight {
        .itemTitle {
          color: #da261d;
        }
        .itemContent {
          color: #da261d;
        }
      }
    }
  }
}
</style>
